import { createSelector } from '@reduxjs/toolkit';

import { ReducerState } from '../common/lib/reducerState';
import { Selector } from '../common/types/selector';
import { PlayerState } from './playerState';

export const selectPlayerState = (tableId: string): Selector<PlayerState | undefined> =>
  createSelector(
    [(state: ReducerState) => state.players],
    (players: Record<string, PlayerState>) => players?.[tableId],
  );
